import { Check, Link } from 'lucide-react';
import React, { useState } from 'react';
import { NotificationPermissionPointer } from '../../pages/onboarding/components/NotificationPermissionPointer';
import tiktokLogo from "../../shared/assets/img/tiktokLogo.svg";
import { Button } from './Button';
import { ButtonsGroup } from './ButtonsGroup';
import { OllieFloating } from './OllieFloating';
import { SpeechBubble } from './SpeechBubble';

export const TikTokBrowserScreen: React.FC = () => {
    const [copySuccess, setCopySuccess] = useState(false);

    const handleCopyUrl = async () => {
        try {
            await navigator.clipboard.writeText(window.location.href);
            setCopySuccess(true);
            setTimeout(() => setCopySuccess(false), 2000);
        } catch (err) {
            console.error('Failed to copy URL:', err);
        }
    };

    const handleContinueAnyway = () => {
        // Set bypass flag in localStorage so the warning won't show again
        localStorage.setItem('tiktok_browser_bypass', 'true');
        // Force a re-render by reloading the page
        window.location.reload();
    };

    return (
        <div className='w-full h-svh overflow-hidden flex flex-col'>
            <div className="flex flex-col gap-10 safe-pb-4 safe-pt-4 px-8 flex-1 overflow-hidden">
                <NotificationPermissionPointer />
                <div className='border-2 border-osGrey-1 rounded-xl relative w-fit max-w-[90%] mx-auto text-osBlack font-semibold text-balance p-3 text-center'>
                    <span className='text-osGrey-2'> On TikTok?,</span>
                    <span className='text-osBlack'> hit the 3-dots (...) </span>
                    <span className='text-osGrey-2'>at the top right and </span>
                    <span className='text-osBlack'>tap “Open in Browser” </span>
                    <span className='text-osGrey-2'>to continue</span>
                    <img src={tiktokLogo} alt="tiktok" className='w-6 h-6 absolute top-2 left-2' />
                </div>
                {/* Ollie Character */}
                <div className='flex-1 flex flex-col justify-center items-center'>
                    <div className='flex flex-col items-center justify-end overflow-show text-center h-[250px]'>
                        <SpeechBubble
                            text="Hey Warrior :), if your on TikTok please open this experience in the browser, just tap the three (...) dots on top!" />
                        <OllieFloating />
                    </div>
                </div>

                <div className="w-full flex flex-col justify-end">
                    <div className="text-osGrey-2 text-balance text-center px-4">
                        For a smooth and secure experience please open in the browser.
                    </div>
                </div>

                <div className="flex flex-col items-center justify-end gap-4 flex-shrink-0 relative z-10">
                    <ButtonsGroup animated={false}>
                        <Button
                            onClick={handleCopyUrl}
                            variant="black"
                            label={copySuccess ? 'URL Copied!' : 'Or Copy the Link Here'}
                            icon={copySuccess ? <Check /> : <Link />}
                            fullWidth={true}
                        />
                        <Button
                            onClick={handleContinueAnyway}
                            variant="gray"
                            label="Continue here anyway"
                            fullWidth={true}
                        />
                    </ButtonsGroup>
                </div>
            </div>
        </div>
    );
};
